<!--suppress AngularNgOptimizedImage -->
<nav class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false" class="navbar-toggle collapsed"
         href="#" onClick="return false;"></a>
      <a (click)="mobileMenuSidebarOpen($event,'overlay-open')" class="bars" href="#" onClick="return false;"></a>
      <a class="navbar-brand" routerLink={{homePage}}>
        <img alt="" src="assets/images/logopeque.png"/>
        <span class="logo-name" style="color: black; font-size: 20px">RX DIGITAL</span>
      </a>
    </div>
    <!--suppress AngularUndefinedBinding -->
    <div [ngClass]="isNavbarCollapsed ? '' : 'show'" class="collapse navbar-collapse">
      <ul class="float-start collapse-menu-icon">
        <li>
          <button
            (click)="callSidemenuCollapse()"
            class="sidemenu-collapse nav-notification-icons"
            mat-icon-button
            data-tour="header-menu-toggle"
          >
            <i class="material-icons-outlined icon-color">menu</i>
          </button>
        </li>
      </ul>
      <ul class="nav navbar-nav navbar-right">
        <li class="nav-item">
          <button
            mat-icon-button
            matTooltip="TUTORIALES"
            [matMenuTriggerFor]="tutorialMenu"
            data-tour="header-tutorial"
            class="nav-notification-icons"
          >
            <i class="material-icons-outlined icon-color">help_outline</i>
          </button>

          <mat-menu #tutorialMenu="matMenu" class="rmd-menu-premium" xPosition="before" yPosition="below">
            <div class="menu-section-title">TUTORIALES</div>

            <button
              mat-menu-item
              *ngFor="let t of availableTours"
              (click)="startTour(t.id)"
            >
              <app-feather-icons icon="play-circle" class="icon-user"></app-feather-icons>
              {{ t.title }}
            </button>
          </mat-menu>
        </li>

        <li class="nav-item rmd-nav-item" *ngIf="isDoctor">
          <!-- BOTÓN CAMPANA -->
          <button
            #notiTrigger="matMenuTrigger"
            mat-icon-button
            class="nav-notification-icons rmd-icon-btn"
            matTooltip="NOTIFICACIONES"
            [matMenuTriggerFor]="notiMenu"
            (menuOpened)="onNotiMenuOpened()"
          >
            <i
              class="material-icons-outlined icon-color"
              [matBadge]="(unreadCount$ | async) || 0"
              matBadgeColor="warn"
              matBadgeOverlap="true"
              matBadgeHidden="((unreadCount$ | async) || 0) === 0"
            >
              notifications
            </i>
          </button>

          <!-- MENU -->
          <mat-menu
            #notiMenu="matMenu"
            class="rmd-noti-menu"
            xPosition="before"
            yPosition="below"
          >

            <!-- HEADER -->
            <div class="rmd-noti-head" (click)="$event.stopPropagation()">
              <div class="rmd-noti-title">
                NOTIFICACIONES
                <span
                  class="rmd-noti-pill"
                  *ngIf="((unreadCount$ | async) || 0) > 0"
                >
                  {{ (unreadCount$ | async) || 0 }} NUEVAS
                </span>
              </div>

              <button
                mat-stroked-button
                class="rmd-noti-action"
                (click)="markNotiRead(); $event.stopPropagation()"
                [disabled]="((unreadCount$ | async) || 0) === 0"
              >
                MARCAR TODO COMO LEÍDO
              </button>
            </div>

            <div class="rmd-noti-divider"></div>

            <!-- LISTA -->
            <div class="rmd-noti-list" (click)="$event.stopPropagation()">
              <ng-container *ngIf="(notifications$ | async) as notis">

                <!-- EMPTY STATE -->
                <div class="rmd-noti-empty" *ngIf="!notis?.length">
                  <div class="rmd-noti-empty-icon">
                    <i class="material-icons-outlined">notifications_off</i>
                  </div>
                  <div class="rmd-noti-empty-title">
                    SIN NOTIFICACIONES
                  </div>
                  <div class="rmd-noti-empty-sub">
                    CUANDO LLEGUE UNA, APARECERÁ AQUÍ.
                  </div>
                </div>

                <!-- CARDS -->
                <div class="rmd-noti-cards" *ngIf="notis?.length">

                  <button
                    type="button"
                    class="rmd-noti-card"
                    *ngFor="let n of notis; let i = index"
                    (click)="openNotification(n)"
                  >
                    <!-- DOT -->
                    <div
                      class="rmd-noti-dot"
                      [class.on]="i < ((unreadCount$ | async) || 0)"
                    ></div>

                    <!-- CONTENT -->
                    <div class="rmd-noti-content">
                      <div class="rmd-noti-item-title">
                        {{ n.titulo }}
                      </div>

                      <div class="rmd-noti-item-sub">
                <span
                  class="rmd-noti-patient"
                  *ngIf="n.nombrePaciente"
                >
                  {{ n.nombrePaciente }}
                </span>

                        <span
                          class="rmd-noti-sep"
                          *ngIf="n.nombrePaciente"
                        >
                  •
                </span>

                        <span class="rmd-noti-msg">
                  {{ n.mensaje }}
                </span>
                      </div>
                    </div>

                    <!-- CHEVRON -->
                    <div class="rmd-noti-chevron">
                      <i class="material-icons-outlined">
                        chevron_right
                      </i>
                    </div>
                  </button>

                </div>

              </ng-container>
            </div>
          </mat-menu>
        </li>

        <li class="nav-item user_profile">
          <button mat-button [matMenuTriggerFor]="profilemenu" #profileMenuTrigger="matMenuTrigger" data-tour="header-profile">
            <div class="chip dropdown-toggle">
              <span>{{ userName }}</span>
              <img alt="User" class="user_img" height="32" [src]="userImage" width="32">
            </div>
          </button>

          <!-- Menu principal -->
          <mat-menu #profilemenu="matMenu" class="rmd-menu-premium" xPosition="before" yPosition="below">
            <div class="menu-section-title">CUENTA</div>
            <button mat-menu-item (click)="profile()" data-tour="menu-profile">
              <app-feather-icons icon="user" class="icon-user"></app-feather-icons>
              PERFIL
            </button>
            <button mat-menu-item (click)="openLegalPolicies()">
              <app-feather-icons icon="book-open" class="icon-user"></app-feather-icons>
              PRIVACIDAD Y LEGAL
            </button>
            <button mat-menu-item (click)="logout()" data-tour="menu-logout">
              <app-feather-icons icon="log-out" class="icon-logout"></app-feather-icons>
              SALIR
            </button>
            <mat-divider></mat-divider>

            <ng-container *ngIf="isAdmin && businessGroups?.length">
              <div class="menu-section-title">GRUPOS</div>
              <button mat-menu-item [matMenuTriggerFor]="groupsMenu" data-tour="menu-groups">
                <app-feather-icons icon="users" class="icon-users"></app-feather-icons>
                VER GRUPOS
                <span class="badge badge-group" *ngIf="businessGroups.length">{{ businessGroups.length }}</span>
              </button>
              <mat-divider></mat-divider>
            </ng-container>

            <ng-container *ngIf="(isAdmin || isSupervisor || isParticular) && branches?.length">
              <div class="menu-section-title">{{ 'SUCURSALES' | regionWord }}</div>
              <button mat-menu-item [matMenuTriggerFor]="branchesMenu" data-tour="menu-branches">
                <app-feather-icons icon="map-pin" class="icon-branch"></app-feather-icons>
                {{ 'VER SUCURSALES' | regionWord }}
                <span class="badge badge-branch" *ngIf="branches.length">{{ branches.length }}</span>
              </button>
              <mat-divider></mat-divider>
            </ng-container>

            <ng-container *ngIf="!isPaciente && alertTypes?.length">
              <div class="menu-section-title">ALERTAS Y NOTICIAS</div>
              <button mat-menu-item [matMenuTriggerFor]="alertsMenu">
                <app-feather-icons icon="alert-triangle" class="icon-alert"></app-feather-icons>
                VER ALERTAS/NOTICIAS
                <span class="badge badge-alert" *ngIf="alertTypes.length">{{ alertTypes.length }}</span>
              </button>
            </ng-container>
          </mat-menu>

          <!-- SUBMENU GRUPOS -->
          <mat-menu #groupsMenu="matMenu" xPosition="before">
            <div class="sub-section-title">GRUPOS</div>
            <div class="groups-scroll">
              @for (grupo of businessGroups; track grupo) {
                <button mat-menu-item (click)="changeBusinessGroupId(grupo.idGEMP)" [ngClass]="{ highlight: businessGroupId == grupo.idGEMP }">
                  <ng-container *ngIf="grupo.logoBase64 && grupo.logoBase64.length > 0; else usersIcon">
                    <img
                      [src]="'data:image/png;base64,' + grupo.logoBase64"
                      style="width:26px; height:26px; border-radius:50%; margin-right:10px;"
                      alt="{{grupo.nombre}}"
                    />
                  </ng-container>
                  <ng-template #usersIcon>
                    <app-feather-icons icon="users" class="icon-users"></app-feather-icons>
                  </ng-template>
                  <span class="menu-title">{{ grupo.nombre }}</span>
                </button>
              }
            </div>
          </mat-menu>

          <!-- SUBMENU SUCURSALES -->
          <mat-menu #branchesMenu="matMenu" xPosition="before">
            <div class="menu-section-title">{{ 'SUCURSALES' | regionWord }}</div>
            <div class="branch-scroll">
              @for (sucursal of branches; track sucursal.idSucursal) {
                <button mat-menu-item (click)="changeBranchGroupId(sucursal.idSucursal)" [ngClass]="{ highlight: branchGroupId == sucursal.idSucursal }">
                  <app-feather-icons icon="map-pin" class="icon-branch"></app-feather-icons>
                  <span class="menu-title">{{ sucursal.nombre }}</span>
                </button>
              }
            </div>
          </mat-menu>

          <!-- SUBMENU ALERTAS -->
          <mat-menu #alertsMenu="matMenu" xPosition="before">
            <div class="sub-section-title">ALERTAS Y NOTICIAS</div>
            <div class="alerts-scroll">
              @for (alertType of alertTypes; track alertType) {
                <button mat-menu-item (click)="openAlertType(alertType)">
                  <app-feather-icons icon="alert-circle" class="icon-alert"></app-feather-icons>
                  <span class="menu-title">{{ alertType.description }}</span>
                </button>
              }
            </div>
          </mat-menu>
        </li>
      </ul>
    </div>

  </div>
</nav>
